import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Inicio } from './screens/inicio/inicio';
import { MenuLateral } from './components/menuLateral/menuLateral';
import { MinhaDieta } from './screens/minha-dieta/minha-dieta';
import { MetodoAscend } from './screens/metodo-ascend/metodo-ascend';
import { Comunidade } from './screens/comunidade/comunidade';
import { MinhaAgenda } from './screens/minha-agenda/minha-agenda';
import { Evolucao } from './screens/evolucao/evolucao';
import { DuvidasIa } from './screens/duvidas-ia/duvidas-ia';
import { Login } from './screens/login/login';
import { Exames } from './screens/exames/exames';
import { Pacientes } from './screens/pacientes/pacientes';
import { Paciente } from './screens/paciente/paciente';
import { Dietas } from './screens/dietas/dietas';
import { MeuPerfil } from './screens/meu-perfil/meu-perfil';
import { Usuarios } from './screens/usuarios/usuarios';
import { Usuario } from './screens/usuario/usuario';
import { Configuracoes } from './screens/configuracoes/configuracoes';
import { Agenda } from './screens/agenda/agenda';
import PoliticaPrivacidade from './screens/politica-privacidade/politica-privacidade';

function LayoutComMenu() {
  return (
    <>
      <MenuLateral />
      <div className="App">
        <Outlet />
      </div>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-center"
        autoClose={4000}
        closeButton={false}
        pauseOnHover={false}
        pauseOnFocusLoss={false}

      />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />

        <Route element={<LayoutComMenu />}>
          <Route path="/inicio" element={<Inicio />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/configuracoes" element={<Configuracoes />} />
          <Route path="/minha-dieta" element={<MinhaDieta />} />
          <Route path="/meu-perfil" element={<MeuPerfil />} />
          <Route path="/dietas" element={<Dietas />} />
          <Route path="/usuarios" element={<Usuarios />} />
          <Route path="/usuario/:id" element={<Usuario />} />
          <Route path="/pacientes" element={<Pacientes />} />
          <Route path="/paciente/:id" element={<Paciente />} />
          <Route path="/exames" element={<Exames />} />
          <Route path="/metodo-ascend" element={<MetodoAscend />} />
          <Route path="/comunidade" element={<Comunidade />} />
          <Route path="/minha-agenda" element={<MinhaAgenda />} />
          <Route path="/evolucao" element={<Evolucao />} />
          <Route path="/duvidas-ia" element={<DuvidasIa />} />
        </Route>

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
